import { makeStyles } from "@material-ui/core/styles";
const FTLPureTableStyle = makeStyles({
    table: {
        minWidth: 650,
    },
    visuallyHidden: {
        border: 0,
        clip: 'rect(0 0 0 0)',
        height: 1,
        margin: -1,
        overflow: 'hidden',
        padding: 0,
        position: 'absolute',
        top: 20,
        width: 1,
    },
});
export default FTLPureTableStyle;
//# sourceMappingURL=FTLPureTableStyle.js.map